/**
 * Whether the rail is pinned open.
 *
 * The frame's own rule: the rail is a column of icons that expands on a
 * deliberate hover, and the menu button pins it open for good. The choice is
 * the browser's, like the rest of the layout, and it is stored the way the
 * frame stores it - '1' or '0' under the app's key.
 */

const KEY = 'brunel.command.rail.pinned';

interface StringStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

/** Pinned open last time? A store that cannot be read means no. */
export function recallRailPinned(store: StringStore | null): boolean {
  if (store === null) return false;
  try {
    return store.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** Remember it. A browser with storage turned off simply does not. */
export function rememberRailPinned(store: StringStore | null, pinned: boolean): void {
  if (store === null) return;
  try {
    store.setItem(KEY, pinned ? '1' : '0');
  } catch {
    /* nothing to say to the owner about this */
  }
}
